/// <reference types="./page.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $data_source from "../data/data_source.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class PagePayload extends $CustomType {
  constructor(page_size, page_index) {
    super();
    this.page_size = page_size;
    this.page_index = page_index;
  }
}

export class Pagination extends $CustomType {
  constructor(total, page_size, page_index, page_count, elements) {
    super();
    this.total = total;
    this.page_size = page_size;
    this.page_index = page_index;
    this.page_count = page_count;
    this.elements = elements;
  }
}

export class DataSourceFilter extends $CustomType {
  constructor(tag, owner, status, search) {
    super();
    this.tag = tag;
    this.owner = owner;
    this.status = status;
    this.search = search;
  }
}

export class ProposalElementFilter extends $CustomType {
  constructor(status, owner) {
    super();
    this.status = status;
    this.owner = owner;
  }
}

export function page_decoder(element_decoder) {
  return $decode.field(
    "total",
    $decode.int,
    (total) => {
      return $decode.field(
        "page_size",
        $decode.int,
        (page_size) => {
          return $decode.field(
            "page_index",
            $decode.int,
            (page_index) => {
              return $decode.field(
                "page_count",
                $decode.int,
                (page_count) => {
                  return $decode.field(
                    "elements",
                    element_decoder,
                    (elements) => {
                      return $decode.success(
                        new Pagination(
                          total,
                          page_size,
                          page_index,
                          page_count,
                          elements,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function page_encoder(page, element_encoder) {
  return $json.object(
    toList([
      ["total", $json.int(page.total)],
      ["page_size", $json.int(page.page_size)],
      ["page_index", $json.int(page.page_index)],
      ["page_count", $json.int(page.page_count)],
      ["elements", $json.array(page.elements, element_encoder)],
    ]),
  );
}

export function compute_page_count(element_count, page_size) {
  let _block;
  let _pipe = element_count;
  let _pipe$1 = $int.divide(_pipe, page_size);
  _block = $result.unwrap(_pipe$1, 0);
  let full_pages = _block;
  let $ = (() => {
    let _pipe$2 = element_count;
    let _pipe$3 = $int.modulo(_pipe$2, page_size);
    return $result.unwrap(_pipe$3, 0);
  })();
  if ($ === 0) {
    return full_pages;
  } else {
    return full_pages + 1;
  }
}

export const max_page_size = 50;

export const default_page_size = 20;

export function page_payload(page_index) {
  return new PagePayload(default_page_size, page_index);
}

export const default_page = /* @__PURE__ */ new PagePayload(
  default_page_size,
  0,
);

export const max_page = /* @__PURE__ */ new PagePayload(default_page_size, 0);

export const empty_page = /* @__PURE__ */ new Pagination(
  0,
  0,
  0,
  0,
  /* @__PURE__ */ toList([]),
);
